export const config = {
    "brush2": {
        penColours: [0XB0B6BE, 0x2B2C2F],
        penScale: [0.12, 0.117, 0.12],
        penPos: [0, 0.0014, 0.0038],

        packGlbScale: [241, 241, 241],
        packGlbPos: [-0.015, -0.55, -0.052],

        paperGlbScale: [17.41, 9.5, 9.5],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [5.171, 2],

        penColour: 0xD42737,
        videoScale: 0.86,
        videoOffset: 0.1,
        penAnimScale: 18

    },
    "brush5": {
        penColours: [0xD42737, 0xFFD82B, 0x42B777, 0x0062A2, 0x663AB5],
        penScale: [0.125, 0.12, 0.12],
        penPos: [0, 0.0031, 0.004],

        packGlbScale: [146.5, 146.5, 146.5],
        packGlbPos: [-0.01, -0.17, -0.034],

        paperGlbScale: [11.02, 9.51, 9.51],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [3.27, 2],

        penColour: 0xD42737,
        videoScale: 0.55,
        videoOffset: 0.43,
        penAnimScale: 10.9
    },
    "brush12": {
        penColours: [0xD42737, 0xF48353, 0xFFD82B, 0x42B777, 0x54BBAA, 0x008586, 0x0062A2, 0x663AB5, 0xD398C4, 0xE5E7E6, 0XB0B6BE, 0x2B2C2F],
        penScale: [0.116, 0.11, 0.114],
        penPos: [0, 0.008, 0.0039],

        packGlbScale: [82, 82, 82],
        packGlbPos: [-0.025, -0.002, -0.0015],

        paperGlbScale: [5.95, 9.49, 5.95],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [1.77, 2],

        penColour: 0xD42737,
        videoScale: 0.3,
        videoOffset: 1.19,
        penAnimScale: 5.78

    },

    "bullet2": {
        penColours: [0XB0B6BE, 0x2B2C2F],
        penScale: [0.11, 0.107, 0.11],
        penPos: [0, 0.00155, 0.0042],

        packGlbScale: [240, 240, 240],
        packGlbPos: [0.29, -0.55, -0.081],

        paperGlbScale: [16.05, 9.5, 9.5],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [4.77, 2],

        penColour: 0x54BBAA,
        videoScale: 0.86,
        videoOffset: 0.08,
        penAnimScale: 16.2

    },
    "bullet5": {
        penColours: [0xD42737, 0xFFD82B, 0x42B777, 0x0062A2, 0x663AB5],
        penScale: [0.106, 0.103, 0.105],
        penPos: [0, 0.0032, 0.0042],

        packGlbScale: [151, 151, 151],
        packGlbPos: [0.03, -0.22, -0.052],

        paperGlbScale: [9.97, 9.5, 9.5],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [2.96, 2],

        penColour: 0x54BBAA,
        videoScale: 0.53,
        videoOffset: 0.44,
        penAnimScale: 10

    },
    "bullet12": {
        penColours: [0xD42737, 0xF48353, 0xFFD82B, 0x42B777, 0x54BBAA, 0x008586, 0x0062A2, 0x663AB5, 0xD398C4, 0xE5E7E6, 0XB0B6BE, 0x2B2C2F],
        penScale: [0.107, 0.107, 0.107],
        penPos: [0, 0.008, 0.0043],


        packGlbScale: [76, 77, 76],
        packGlbPos: [0.045, 0.065, -0.00063],

        paperGlbScale: [5.25, 9.5, 5.25],
        paperGlbPos: [0, 0, 0.1],

        paperScale: [1.56, 2],

        penColour: 0x54BBAA,
        videoScale: 0.3,
        videoOffset: 1.165,
        penAnimScale: 5.2

    },
}
